module.exports = __webpack_public_path__ + "img/头像.b09cec68.png";